import { render, staticRenderFns } from "./AddCurpTarjeta.vue?vue&type=template&id=bf5259d6&"
import script from "./AddCurpTarjeta.vue?vue&type=script&lang=js&"
export * from "./AddCurpTarjeta.vue?vue&type=script&lang=js&"
import style0 from "./AddCurpTarjeta.vue?vue&type=style&index=0&id=bf5259d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports